"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrackingParams = void 0;

var getTrackingParams = function getTrackingParams(state) {
  return state.trackingParams;
};

exports.getTrackingParams = getTrackingParams;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/trackingParams.js
// module id = 798
// module chunks = 209 210 211 212